import CustomIconButton from "@shared-ui-components/CustomIconButton";
import { FC, useContext } from "react";

import TrailingIcon from "@icons/trailingIcon.svg";
import Colors from "@src/constants/Colors";
import HistoricalReportContext from "@src/context/HistoricalReports/historicalReportContext";
import {
  StyledBox,
  StyledButton,
  StyledGrid,
  StyledTypography,
} from "../style";

declare interface HrNavBarProps {
  isDesktop: boolean;
}

const HrNavBar: FC<HrNavBarProps> = ({ isDesktop }) => {
  const [{ historicalReportState, historicalReportSetState }] = useContext(
    HistoricalReportContext
  );

  const { tab, filterType } = historicalReportState;

  const handleTabClick = (selectedTab: string) => {
    historicalReportSetState((pre: HistoricalReportStateType) => {
      return {
        ...pre,
        tab: selectedTab,
      };
    });
  };

  const handleEventChangeClick = () => {
    historicalReportSetState((pre: HistoricalReportStateType) => {
      return {
        ...pre,
        eventOpen: true,
      };
    });
  };

  return (
    <StyledGrid isDesktop={isDesktop}>
      <StyledBox>
        <StyledButton
          variant={tab === "MTD" ? "contained" : "text"}
          backgroundColor={tab === "MTD" ? Colors.primary : Colors.white}
          onClick={() => handleTabClick("MTD")}
        >
          MTD
        </StyledButton>
        <StyledButton
          variant={tab === "YTD" ? "contained" : "text"}
          backgroundColor={tab === "YTD" ? Colors.primary : Colors.white}
          onClick={() => handleTabClick("YTD")}
        >
          YTD
        </StyledButton>
      </StyledBox>
      <StyledBox onClick={handleEventChangeClick}>
        <StyledTypography>By {filterType}</StyledTypography>
        <CustomIconButton
          className="icon"
          handleClick={handleEventChangeClick}
          icon={TrailingIcon}
          ariaLabel="home"
        />
      </StyledBox>
    </StyledGrid>
  );
};

export default HrNavBar;
